<template>
  <div class="c-main">
    <h3>{{$t('participation.addTeam')}}</h3>
    <participant @submit="update($event)" @cancel="cancel()" participantType="team" />
  </div>
</template>

<script>
	export default {
		name: "participant-addTeam",
    components: {
      participant: require('./participation.vue').default,
    },
		methods: {
			update: function(data) {
        this.$notify.saveAsync(
            this.$t('participation'),
            this.$store.dispatch('participation.add', {data: data}),
            () => {
              this.$navigation.goto({name: 'admin.event.discipline.participantsTeam'});
            }
        );
			},
      cancel: function() {
        this.$navigation.goto({name: 'admin.event.discipline.participantsTeam'})
      },
		},
	};
</script>

<style>
</style>
